module.exports = __webpack_public_path__ + "media/images/sp/stores/asakusa/asakusa_sns_05-028f57db3608b05dc3be4f095fa51de3.jpg";